import PluginAction from '../plugin-action';

/**
 * Basic step action for a teacher or vendor registration.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class AbstractStepAction extends PluginAction {
    /**
     * The main form of the action.
     */
    protected form: HTMLFormElement;

    protected constructor(container: HTMLElement) {
        super(container);
        const form = container.querySelector<HTMLFormElement>('form#registration');
        if (!form) {
            throw new Error('Required elements missing.');
        }
        this.form = form;
    }
}
